
import Edit from "../../../assets/filled/Edit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EditIcon({ className, dataTestid = "EditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Edit data-testid={dataTestid} className={classes} {...rest} />
  );
}
